import { render } from "./mainPopup.vue?vue&type=template&id=40cefbb8"
import script from "./mainPopup.vue?vue&type=script&lang=js"
export * from "./mainPopup.vue?vue&type=script&lang=js"

import "./mainPopup.vue?vue&type=style&index=0&id=40cefbb8&lang=css"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__